import { render, staticRenderFns } from "./mgrTrip.vue?vue&type=template&id=27b3a115&scoped=true&"
import script from "./mgrTrip.vue?vue&type=script&lang=js&"
export * from "./mgrTrip.vue?vue&type=script&lang=js&"
import style0 from "./mgrTrip.vue?vue&type=style&index=0&id=27b3a115&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b3a115",
  null
  
)

export default component.exports